<template>
  <div v-if="applicant" id="applicant-edit-tab-personal-data">
    <ValidationObserver ref="PersonalData" tag="form">
      <PersonalData v-model="internalValue" />
    </ValidationObserver>
    <div style="text-align: right">
      <vs-button class="mt-3" @click="save()">Speichern</vs-button>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
import PersonalData from "../form/PersonalData";
import editFormMixin from "@/mixins/editFormMixin.js";

const fieldRequests = `
  id
  birthday
  birthplace
  civilStatus
  salutationType
  salutation
  title
  firstName
  lastName
  nationality
  residentPermit
  imageID
  kids
  source {
    id
    name
  }
  contactDataCompany {
    email
    telephone
    telephoneMobile
  }
  contactData {
    email
    telephone
    telephoneMobile
    address {
      street
      zip
      city
      country
      lat
      lng
    }
  }
  covidVaccination {
     id
     state
     lastVaccinationForCompleteCoverage
     lastPCRTestDateForRecovery
  }
`;

const APPLICANT_QUERY = gql`
  query Applicant($id: ID!) {
    applicant(id: $id) {
      ${fieldRequests}
    }
  }
`;

export default {
  components: {
    PersonalData
  },
  mixins: [
    editFormMixin({
      legacyIDFields: ["source"]
    })
  ],
  data() {
    return {
      fetchFailed: false
    };
  },
  apollo: {
    applicant: {
      query: APPLICANT_QUERY,
      update: data => {
        let applicant = data.applicant;
        if (!applicant.covidVaccination) {
          applicant.covidVaccination = {
            state: "UNKNOWN",
            lastVaccinationForCompleteCoverage: "",
            lastPCRTestDateForRecovery: ""
          };
        }
        if (!applicant.contactDataCompany) {
          applicant.contactDataCompany = {};
        }

        if (!applicant.contactData) {
          applicant.contactData = { address: {} };
        }

        return data.applicant;
      },
      result() {
        this.updateCurrent();
      },
      variables() {
        return {
          id: this.$route.params.id
        };
      }
    }
  },
  computed: {
    internalValue: {
      get() {
        return this.applicant;
      },
      set() {
        this.save(false);
      }
    }
  },
  methods: {
    async persist() {
      let result = await this.$refs.PersonalData.validate();
      if (result == true) {
        let input = this.getInput();
        this.$apollo
          .mutate({
            mutation: gql`
              mutation($id: ID!, $input: ApplicantInput!) {
                updateApplicant(id: $id, input: $input) {
                  id
                }
              }
            `,
            variables: {
              id: this.applicant.id,
              input
            }
          })
          .then(() => {
            this.reportSuccess(input);
          })
          .catch(error => {
            this.reportUnhandledError(error);
          });
      } else {
        this.$vs.notify({
          title: "Speichern fehlgeschlagen",
          text: "Bitte überprüfe ob alle Pflichtfelder eingetragen sind.",
          color: "danger",
          icon: "query_builder",
          position: "bottom-center",
          time: 5000
        });
      }
    }
  }
};
</script>
